import { api } from "../index";

export const locationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLocationData: builder.query({
      queryFn: async () => {
        try {
          const response = await fetch(
            `https://api.ipinfo.io/lite/me?token=${process.env.REACT_APP_IPINFO_TOKEN}`,
            { signal: AbortSignal.timeout(5000) }
          );
          const data = await response.json();

          const transformedData = {
            ...data,
            country: data.country_code,
            country_name: data.country,
          };

          return { data: transformedData };
        } catch (error) {
          return { data: { country: "KW" } };
        }
      },
      // Keep data in cache basically forever (e.g. 24 hours)
      keepUnusedDataFor: 86400, 
    }),
    getCurrency: builder.query({
      query: (params) => ({
        url: "/api/v1/currency-detect",
        method: "GET",
        params,
      })
    }),
  }),
});

export const { useGetLocationDataQuery, useGetCurrencyQuery } = locationApi;
